import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import InfiniteScroll from "../../Components/Functionality/InfiniteScrollList";
import Container from "../../Components/UI/Container";
import { useDebatesStatusStore, useUserStore } from "../../Context/store";
import { useSubworkspaceStore } from "../../Context/store";
import {
  useDebateReadMutation,
  useGetPrivateUserWiseDebatedList,
} from "../../Web-Hooks/Debate/use-debate";
import Posts from "../Posts/Posts";

const Private = () => {
  const location = useLocation();
  const { pathname } = location;
  const opponentId = pathname.slice(1).split("/")[1];
  const { selectedSubWorkspace } = useSubworkspaceStore();
  const { user } = useUserStore();
  const QueryKey = [
    "private-subworkspace",
    user?.userId,
    selectedSubWorkspace?.subWorkSpaceId,
    opponentId,
  ];
  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useGetPrivateUserWiseDebatedList(
    user?.userId,
    selectedSubWorkspace?.subWorkSpaceId,
    opponentId
  );

  const { mutateAsync: readStatus, isPending } = useDebateReadMutation();

  const { currentForumStatus } = useDebatesStatusStore();

  const hasNewDebates =
    isLoading || isPending
      ? false
      : opponentId
      ? currentForumStatus?.sections?.privateFeed?.userSections?.includes(
          opponentId
        )
      : currentForumStatus?.sections?.privateFeed?.userSections?.length > 0;

  useEffect(() => {
    readStatus({
      userId: user?.userId,
      subWorkSpaceId: selectedSubWorkspace?.subWorkSpaceId,
      sectionType: "private",
      opponentId: opponentId,
    });
  }, [
    readStatus,
    user?.userId,
    selectedSubWorkspace?.subWorkSpaceId,
    opponentId,
  ]);

  const handleRefetch = async () => {
    readStatus({
      userId: user?.userId,
      subWorkSpaceId: selectedSubWorkspace?.subWorkSpaceId,
      sectionType: "private",
      opponentId: opponentId,
    });
    const response = await refetch();
    return response;
  };

  return (
    <Container>
      {/* Title */}
      <InfiniteScroll
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isLoading={isLoading}
        hasNewData={hasNewDebates}
        refetch={handleRefetch}
        queryKey={QueryKey}
      >
        <Posts
          apiType={pathname}
          user={user}
          isLoading={isLoading && !isFetchingNextPage}
          AllDebates={data?.pages?.flatMap((page) => page.privateDebateLists)} // Combine all pages
        />
      </InfiniteScroll>
    </Container>
  );
};

export default Private;
